export default __webpack_public_path__ + "static/sky-2.0-780c7d5b3c59d7e6961befca6c71c193.jpg";